var _path, _rect, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 35,
    fill: "currentColor",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 11,11 -4.5,2 4.5,2 4.5,-2 z m 5,3 -4.5,2 v 5 L 16,19 Z M 6,14 v 5 l 4.5,2 v -5 z",
    stroke: "none"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 34,
    rx: 3.5,
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 1,4.5 H 21"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 1,27.5 H 21"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 1.0408534,3.7109375 C 1,1 2.6361486,1.1503058 3.4962809,1 4.3564132,0.84969415 18.109828,0.93116858 18.503719,1 19.831329,1.2319964 20.252748,1.2778364 20.842676,1.952726 21.291525,2.4662183 21,4.5 21,4.5 L 11,3.984375 0.5,3.984 Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 3.2691457,34 C 2.0911404,33.691148 1.1440278,32.539276 1,31.281 0.9667648,30.990647 1.031964,30.140832 1.031704,29.392261 L 1.0312311,28.03122 H 11 20.968768 l -4.98e-4,1.361041 C 20.96802,30.140832 21.03324,30.990647 21,31.281 20.855972,32.539276 19.908834,33.691148 18.730829,34 18.35449,34.09868 17.719574,33.96878 11.000001,33.96878 4.2804267,33.96878 3.6455107,34.098706 3.2691457,34 Z m 8.5484423,-1.133184 c 0.414136,-0.184424 0.769616,-0.534171 0.986992,-0.971074 0.164427,-0.330486 0.189173,-0.447188 0.189173,-0.892135 0,-0.444947 -0.02474,-0.561648 -0.189173,-0.892135 -0.215772,-0.433679 -0.568563,-0.782527 -0.986992,-0.975956 -0.406699,-0.18801 -1.228478,-0.18801 -1.635176,0 -0.4184287,0.193429 -0.7712203,0.542277 -0.9869912,0.975956 -0.1641751,0.329977 -0.1890945,0.447127 -0.1885661,0.886486 4.984e-4,0.399731 0.031532,0.572962 0.147567,0.823236 0.2623955,0.565963 0.6789105,0.944636 1.2427273,1.12982 0.358815,0.117852 1.060065,0.07628 1.420439,-0.08419 z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppActive);
export default __webpack_public_path__ + "static/media/app-active.e66214b46010db3387be8eaf171b3c77.svg";
export { ForwardRef as ReactComponent };